const canRenderTop = ({ triggerTop = 0, dropdownContentHeight = 0, }) => triggerTop >= dropdownContentHeight;
const canRenderRight = ({ screenWidth, triggerRight = 0, dropdownContentWidth = 0, }) => screenWidth - triggerRight >=
    dropdownContentWidth + MARGIN_HORIZONTAL_POSITION;
const canRenderBottom = ({ screenHeight, triggerTop = 0, dropdownContentHeight = 0, }) => {
    return screenHeight - triggerTop >= dropdownContentHeight;
};
const canRenderLeft = ({ triggerLeft = 0, dropdownContentWidth = 0, }) => triggerLeft >= dropdownContentWidth;
const canRenderBottomLeft = ({ triggerRight = 0, dropdownContentWidth = 0, }) => triggerRight >= dropdownContentWidth;
const canRenderBottomRight = ({ screenWidth, triggerLeft = 0, dropdownContentWidth = 0, }) => screenWidth - triggerLeft >= dropdownContentWidth;
const MARGIN_VERTICAL_POSITION = 4;
const MARGIN_HORIZONTAL_POSITION = 8;
const calculateDropdownPosition = ({ screenWidth, screenHeight, triggerReference, contentReference, direction, isSubMenu, isLowerResolution, }) => {
    if (typeof window === 'undefined') {
        return {
            top: 0,
            left: 0,
        };
    }
    const { top: triggerTopPosition, left: triggerLeftPosition, right: triggerRightPosition, width: triggerWidth, height: triggerHeight, } = triggerReference.getBoundingClientRect();
    const { width: contentWidth, height: contentHeight } = contentReference.getBoundingClientRect();
    const checkProps = {
        screenWidth,
        screenHeight,
        dropdownContentWidth: contentWidth || 0,
        dropdownContentHeight: contentHeight || 0,
        triggerTop: triggerTopPosition + triggerHeight,
        triggerRight: triggerRightPosition,
        triggerLeft: triggerLeftPosition,
        triggerWidth,
    };
    const getVerticalLeftPosition = () => {
        const verticalTopRightPosition = window.scrollX + triggerLeftPosition;
        if (canRenderBottomRight(checkProps))
            return verticalTopRightPosition;
        if (canRenderBottomLeft(checkProps)) {
            return verticalTopRightPosition - contentWidth + triggerWidth;
        }
        return verticalTopRightPosition;
    };
    const getTopPosition = () => {
        const corretSubMenuTopValue = isSubMenu ? triggerHeight : 0;
        return (triggerTopPosition -
            contentHeight +
            corretSubMenuTopValue -
            (isLowerResolution && isSubMenu ? triggerHeight : 0));
    };
    const positionsFn = {
        top: () => ({
            top: getTopPosition() - MARGIN_VERTICAL_POSITION,
            left: getVerticalLeftPosition(),
        }),
        bottom: () => ({
            top: triggerTopPosition + triggerHeight + MARGIN_VERTICAL_POSITION,
            left: getVerticalLeftPosition(),
        }),
        right: () => ({
            top: canRenderBottom(checkProps)
                ? triggerTopPosition
                : getTopPosition() + triggerHeight,
            left: window.scrollX + triggerRightPosition + MARGIN_HORIZONTAL_POSITION,
        }),
        left: () => ({
            top: canRenderBottom(checkProps)
                ? triggerTopPosition
                : triggerTopPosition + triggerHeight - contentHeight,
            left: window.scrollX +
                triggerLeftPosition -
                contentWidth -
                MARGIN_HORIZONTAL_POSITION,
        }),
    };
    const choosePosition = {
        bottom: () => canRenderBottom(checkProps)
            ? positionsFn.bottom()
            : canRenderTop(checkProps)
                ? positionsFn.top()
                : positionsFn.bottom(),
        top: () => canRenderTop(checkProps)
            ? positionsFn.top()
            : canRenderBottom(checkProps)
                ? positionsFn.bottom()
                : positionsFn.top(),
        right: () => canRenderRight(checkProps) ? positionsFn.right() : positionsFn.left(),
        left: () => canRenderLeft(checkProps) ? positionsFn.left() : positionsFn.right(),
    };
    if (isLowerResolution) {
        return canRenderBottom(checkProps)
            ? positionsFn.bottom()
            : canRenderTop(checkProps)
                ? positionsFn.top()
                : positionsFn.bottom();
    }
    return choosePosition[direction]();
};

export { MARGIN_HORIZONTAL_POSITION, MARGIN_VERTICAL_POSITION, calculateDropdownPosition };
